/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AdasProgramsReportPageIdx, AdasProgramsReportPages, htabIndexToPageMap } from "./constants"

export const getPageFromHtabIndex = (htabIndex: AdasProgramsReportPageIdx): AdasProgramsReportPages => {
  return htabIndexToPageMap[htabIndex]
}
